import { OrgAdminConstants } from '../../../_constants';

const initialState = { resetTeamLeaderLoading: true, data: '', error: false };

export function resetTeamLeaderReducer(state = initialState, action) {

    switch (action.type) {
        case OrgAdminConstants.REQUEST_RESET_TEAM_LEADER:
            return {
                resetTeamLeaderLoading: true,
                data: '',
                error: false
            };
        case OrgAdminConstants.RECEIVE_RESET_TEAM_LEADER:
            return {
                resetTeamLeaderLoading: false,
                data: action.resetTeamLeader,
                error: false
            };
        case OrgAdminConstants.RESET_TEAM_LEADER_ERROR:
            return {
                resetTeamLeaderLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/OrgAdmin/ManageTeam/resetTeamLeader.reducer.js